<!-- 数字运维 -->
<template>
  <div class="dtwin-container">
    <VerticalBanner
      :lists="bannersList"
      :indicatorPosition="'none'"
      :height="'640px'"
      @click="openUrl"
    />
    <Solution />

    <TwinHighwayIntro />

    <TwinWaterwayIntro />

    <TwinCityIntro />

    <!-- 获取产品 -->
    <ProductGet
      title="Infrastructure Operation and Maintenance Digital Twin Solution"
      subTitle="Bringing a new model to the operation and maintenance management of highways, waterways, and city infrastructure!"
      :bgImage="require('@/assets/images/dtwin/getNow_bg.png')"
      :downLoadBtn="{
        label: 'Download Brochure',
        show: true,
      }"
    />
  </div>
</template>

<script>
import VerticalBanner from "@/components/VerticalBanner.vue";
import ProductGet from "@/components/ProductGet.vue";
import Solution from "./Solution.vue";
import TwinCityIntro from "./TwinCityIntro.vue";
import TwinHighwayIntro from "./TwinHighwayIntro.vue";
import TwinWaterwayIntro from "./TwinWaterwayIntro.vue";

import {
  clientBannerListApi,
  listByIdsApi,
  clientHomeVideoApi,
} from "@/api/api";
export default {
  name: "Dtwin",
  components: {
    VerticalBanner,
    Solution,
    TwinCityIntro,
    ProductGet,
    TwinHighwayIntro,
    TwinWaterwayIntro,
  },
  data() {
    return {
      bannersList: [
        {
          id: "1",
          title: "Digital Twin Highway Infrastructure Platform",
          subTitle:
            "Integrating big data, smart sensors, and O&M management enables efficient lifecycle control and precise highway maintenance.",
          picUrl: require("@/assets/images/dtwin/banner1.png"),
          bannerLink: "",
        },
        {
          id: "2",
          title: "Digital Twin Waterway Infrastructure Platform",
          subTitle:
            "Deep integration of multi-source data and full-process management enables precise, intelligent waterway operations. ",
          picUrl: require("@/assets/images/dtwin/banner2.png"),
          bannerLink: "",
        },
        {
          id: "3",
          title: "Digital Twin City Infrastructure Platform",
          subTitle:
            "The integration of AIoT technology with urban life scenarios reshapes the city management experience.",
          picUrl: require("@/assets/images/dtwin/banner3.png"),
          bannerLink: "",
        },
      ],
    };
  },
  created() {
    // this.getBanner();
  },
  methods: {
    openUrl() {
      // TODO
    },
    async getBanner() {
      // let data = await this.bannerApi();
      // this.banners = data
    },

    bannerApi() {
      return new Promise((resolve, reject) => {
        clientBannerListApi().then((res) => {
          if (res.code === 200) {
            resolve(res.rows);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss">
.dtwin-container {
  width: 100%;
  height: 100%;
  .dtwin-get-wrapper {
    width: 990px;
    margin: 0 auto;
    padding: 52px 0;
    text-align: center;
  }
  .dtwin-get {
    width: 100%;
    height: 240px;
    background: url("~@/assets/images/dtwin/getNow_bg.png") no-repeat center;
    background-size: cover;
    color: #fff;
  }
  .dtwin-get-header {
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 24px;
    color: #fff;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .dtwin-get-subTitle {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 18px;
    color: #fff;
    line-height: 27px;
    text-align: justify;
    font-style: normal;
  }
  .dtwin-get-footer {
    text-align: left;
    .dtwin-get-btn {
      padding: 8px 12px;
      font-size: 14px;
      color: #000;
      text-align: center;
      background: #fff;
      border-radius: 2px;
      &:first-child {
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
